import { actions } from '@grandvisionhq/state';

// TODO: this should probably have a stricter type than string,
//  but the ShippingMethod enum lives in the checkout package currently
const setPreferredShippingMethod = actions.action('shipping-methods/set-preferred-shipping-method', actions.payload());

export { setPreferredShippingMethod };
//# sourceMappingURL=actions.js.map
